import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"
import { fetchBanks } from "./useGetBanksList"
import { IBankMeta } from "../interface"
import { fetchPermissionIds } from "./usePermissionIds"
import { RootState } from "../../store/store"

export const GET_PERMISSIONS_BANK_LIST_QUERY_KEY = "get-permission-bank-list"

async function fetchPermissionBankList(token: string | null) {
  const bankPermissions = await fetchPermissionIds(token)
  const banksData = await fetchBanks(token, null)

  const bankPermissionsIds: string[] | undefined = bankPermissions?.permissions
  const banksItems: IBankMeta[] | undefined = banksData?.items
  if (!bankPermissionsIds || !banksItems) {
    throw new Error("Данные отсутствуют")
  }

  const foundBanks = banksItems.filter((bank) =>
    bankPermissionsIds.includes(bank.bankId),
  )

  if (!foundBanks) {
    throw new Error("Отсутствуют банки")
  }

  return foundBanks
}

export const usePermissionBankList = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery({
    queryKey: [GET_PERMISSIONS_BANK_LIST_QUERY_KEY],
    queryFn: () => fetchPermissionBankList(token),
    enabled: !!token,
  })
}
